import styled, { css } from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { AiStoryCreationCard } from "../AiStoryCreationCard";
import { BlankCanvasCard } from "../BlankCanvasCard";
import { StoryTemplateCard } from "../StoryTemplateCard";

/**
 * Figma 5326:88009 — three-up card grid with a 12px gutter. The two methods
 * shown alone (`$columns={2}`) take two columns instead, so no third is left
 * empty; both layouts fall to two, then one, as the dialog narrows.
 */
export const Grid = styled.div<{ $columns?: 2 | 3 }>`
  display: grid;
  grid-template-columns: repeat(
    ${({ $columns = 3 }) => $columns},
    minmax(0, 1fr)
  );
  align-content: start;
  gap: ${spacing[3]};
  width: 100%;
  min-width: 0;

  @media (max-width: 42rem) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 29rem) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

/* Nested under &:hover so the selection outlives the card's own hover rule,
   which would otherwise win on specificity while the pointer rests on the
   card the user just picked. */
const selectedCardStyles = css<{ $selected: boolean }>`
  ${({ $selected }) =>
    $selected &&
    css`
      &,
      &:hover,
      &:hover:not(:disabled) {
        border-color: ${rawColors.primary[500]};
        box-shadow: ${({ theme }) => theme.shadows.interactive.focus};
      }
    `}
`;

export const BlankRecipeCard = styled(BlankCanvasCard)<{
  $selected: boolean;
}>`
  ${selectedCardStyles}
`;

export const AiRecipeCard = styled(AiStoryCreationCard)<{
  $selected: boolean;
}>`
  ${selectedCardStyles}
`;

export const TemplateRecipeCard = styled(StoryTemplateCard)<{
  $selected: boolean;
}>`
  height: 7.25rem;
  min-height: 7.25rem;
  ${selectedCardStyles}
`;
